// src/context/ItineraryContext.tsx
import React, { createContext, useState, ReactNode, useEffect } from 'react';
import { ItinerarioDia, Lugar, obtenerPuntosTuristicos } from '../api/api';

/* --------------------------------------------------------------- */
/* 1) TIPOS AUXILIARES                                             */
/* --------------------------------------------------------------- */

/* ➊ Tu estructura ligera con solo coordenadas  (la dejamos) */
export interface DiaPoints {
  start?: { latitud: number; longitud: number };
  end?:   { latitud: number; longitud: number };
}

/* ➋ NUEVO — diccionarios completos para que MapView no rompa      */
/*     (si prefieres prescindir de ellos después, solo elimina      */
/*     la parte de MapView que los usa y estos ➋ ya no harían falta) */
export type DayStarts = Record<number, Lugar | undefined>;
export type DayEnds   = Record<number, Lugar | undefined>;

/* --------------------------------------------------------------- */
/* 2) TIPO DEL CONTEXTO                                            */
/* --------------------------------------------------------------- */
interface ItineraryContextType {
  itinerarios        : ItinerarioDia[];
  setItinerarios     : React.Dispatch<React.SetStateAction<ItinerarioDia[]>>;

  puntosTuristicos   : Lugar[];
  setPuntosTuristicos: React.Dispatch<React.SetStateAction<Lugar[]>>;

  perfil             : string;
  setPerfil          : React.Dispatch<React.SetStateAction<string>>;

  dias               : number;
  setDias            : React.Dispatch<React.SetStateAction<number>>;

  startingPoint      : Lugar | null;
  setStartingPoint   : React.Dispatch<React.SetStateAction<Lugar | null>>;

  /* —— tu objeto con solo coords ——————————————— */
  dayPoints          : Record<number, DiaPoints>;
  setDayPoints       : React.Dispatch<React.SetStateAction<Record<number, DiaPoints>>>;

  /* —— NUEVO: objetos completos (usados por MapView) —— */
  dayStarts          : DayStarts;
  setDayStarts       : React.Dispatch<React.SetStateAction<DayStarts>>;
  dayEnds            : DayEnds;
  setDayEnds         : React.Dispatch<React.SetStateAction<DayEnds>>;
}

export const ItineraryContext = createContext<ItineraryContextType | undefined>(undefined);

interface Props { children: ReactNode }

/* --------------------------------------------------------------- */
/* 3) PROVIDER                                                     */
/* --------------------------------------------------------------- */
export const ItineraryProvider: React.FC<Props> = ({ children }) => {
  /* existentes -------------------------------------------------- */
  const [itinerarios,      setItinerarios]   = useState<ItinerarioDia[]>([]);
  const [puntosTuristicos, setPuntosTuristicos] = useState<Lugar[]>([]);
  const [perfil,           setPerfil]        = useState('');
  const [dias,             setDias]          = useState(1);
  const [startingPoint,    setStartingPoint] = useState<Lugar | null>(null);

  /* tu estado ligero -------------------------------------------- */
  const [dayPoints, setDayPoints] = useState<Record<number, DiaPoints>>({});

/* NUEVOS estados — usados tal cual en MapView ------------------ */
const [dayStarts, setDayStarts] = useState<DayStarts>({});
const [dayEnds  , setDayEnds  ] = useState<DayEnds>({});


  /* -------------------------------------------------------------- */
  /* cargar POIs externos una única vez                             */
  /* -------------------------------------------------------------- */
  useEffect(() => {
    (async () => {
      try { setPuntosTuristicos(await obtenerPuntosTuristicos()); }
      catch (err) { console.error('Error al obtener puntos turísticos', err); }
    })();
  }, []);

  /* -------------------------------------------------------------- */
  /* expose everything                                              */
  /* -------------------------------------------------------------- */
  return (
    <ItineraryContext.Provider value={{
      itinerarios, setItinerarios,
      puntosTuristicos, setPuntosTuristicos,
      perfil, setPerfil,
      dias, setDias,
      startingPoint, setStartingPoint,

      /* coords-only version */
      dayPoints, setDayPoints,

      /* Lugar-completos — MapView los necesita */
      dayStarts, setDayStarts,
  dayEnds  , setDayEnds,
    }}>
      {children}
    </ItineraryContext.Provider>
  );
};
